import React from "react";

import "../App.css";

const Float = () => {
  return (
    <div className="float">
      <a href="https://ventu.cl/cornerdog">
        <img src="/img/a1.png" alt=""></img>
        <p>Comprar Snacks Naturales</p>
      </a>
    </div>
  );
};

export default Float;
